import { Injectable } from '@angular/core';
import { Rest, RestService } from '@ralba/shared';
import {
  AttachmentDto,
  GetArtifactAttachments,
  GetAttachmentArtifactDto,
  TenancyRequestDto,
  UploadArtifactAttachment,
} from '../dto';

@Injectable({ providedIn: 'root' })
export class EmployeeArtifactAttachmentHttpApiService {
  constructor(private rest: RestService) {}

  public get(params: TenancyRequestDto<GetArtifactAttachments>) {
    const request: Rest.Request<null> = {
      method: 'GET',
      url: '/api/employee/artifact-attachment/get',
      params,
    };
    return this.rest.request<null, Rest.AbpResponse<AttachmentDto[]>>(request);
  }

  public delete(params: TenancyRequestDto<GetAttachmentArtifactDto>) {
    const request: Rest.Request<null> = {
      method: 'DELETE',
      url: '/api/employee/artifact-attachment/delete',
      params,
    };
    return this.rest.request<null, Rest.AbpResponse<null>>(request);
  }

  public upload(body: TenancyRequestDto<UploadArtifactAttachment>) {
    const request: Rest.Request<TenancyRequestDto<UploadArtifactAttachment>> = {
      method: 'POST',
      url: '/api/employee/artifact-attachment/upload',
      body,
    };
    return this.rest.request<
      TenancyRequestDto<UploadArtifactAttachment>,
      Rest.AbpResponse<null>
    >(request);
  }
}
